import React from "react";
import { Container } from "react-bootstrap";
import {
  FaBatteryFull,
  FaTrain,
  FaCarSide,
  FaThermometerHalf,
} from "react-icons/fa";
import { GiRaceCar } from "react-icons/gi";
import { MdEngineering } from "react-icons/md";

function Projects() {
  const projects = [
    {
      icon: <FaBatteryFull />,
      title: "Air Cooled Battery Pack for FSAE EV",
      org: "Formula Student Team",
      description:
        "Designed a high-capacity battery pack with surface cooling using aluminium sandwich mounts for NMC pouch cells. Achieved significant reduction in pressure drop and maximum temperature difference under permissible limits by optimising fan configuration, cell spacings, and airflow rates.",
      tags: ["Ansys Fluent", "Cell Testing", "Thermal Design", "CFD", "Cooling System Design", "Cell Charge/Discharge Test", "NMC Pouch Cells"],
    },
    {
      icon: <FaTrain />,
      title: "Hydrogen-Powered Miniature Locomotive",
      org: "Railway Challenge Group",
      description:
        "Designed the complete drivetrain of a high-power Hydrogen Fuel Cell hybrid-electric miniature locomotive. Optimized a two-stage suspension system in Simpack with a tuned damping ratio. Crafted a ladder-frame chassis achieving substantial weight reduction.",
      tags: ["Simpack", "Fuel Cell", "Drivetrain", "Chassis Design", "Rail Body Dynamics", "Ansys Structural", "Powertrain Design"],
    },
    {
      icon: <GiRaceCar />,
      title: "Formula Student Prototype Vehicle",
      org: "Formula Student Team",
      description:
        "Modelled aerodynamic package with rear and front wings and underbody diffuser achieving a high downforce coefficient. Manufactured the team's first carbon fibre nose cone in-house using vacuum bagging, reducing cost by a significant margin.",
      tags: ["Aerodynamics", "CFD", "Mechanical Design", "Mechanical Assembly", "Wing Design", "Vehicle Dynamics", "Welding and Machining"],
    },
    {
      icon: <FaThermometerHalf />,
      title: "Battery Thermal Modelling & Simulations",
      org: "IIT Kharagpur",
      description:
        "Executed transient CFD thermal analysis for battery cooling in Ansys Fluent using PISO corrections and UDF-based dynamic heat generation. Cut computational time by several fold through mesh optimisation validated with a mesh independence study.",
      tags: ["MATLAB", "Ansys Fluent", "Mesh Optimization", "Thermal Analysis", "Forced Convection", "Liquid Cooling", "Simulink", "SolidWorks"],
    },
    {
      icon: <FaCarSide />,
      title: "Low-Cost EVAP System for Two Wheelers",
      org: "Bajaj Auto Ltd.",
      description:
        "Designed a cost-effective EVAP system meeting BS-VI emission standards. Achieved significant cost reduction through competitive benchmarking. Engineered compact rollover valve with substantial part count reduction and validated sealing with Ansys CAE analysis.",
      tags: ["Ansys CAE", "Prototype Design", "Cost Reduction", "Fuel System", "Material Selection", "Additive Manufacturing", "Siemens NX"],
    },
    {
      icon: <MdEngineering />,
      title: "Carbon Fibre Structural Analysis for Vehicle Parts",
      org: "Formula Student Team",
      description:
        "Simulated a specimen of CF ply on the Ansys ACP PrepPost module to obtain the structural strength using Tsai Wu Failure Criterion. Fabricated in-house manufactured CF test samples varying the ply angle and number of ply layers using the wet layup technique.",
      tags: ["Ansys ACP", "Composite Analysis", "Carbon Fibre", "Composite Design", "Core Material", "Wet Layup", "Vacuum Bagging", "Mould Design"],
    },
  ];

  return (
    <section className="section">
      <Container>
        <h2 className="section-title fade-in">
          My <span className="purple">Projects</span>
        </h2>
        <p
          className="text-center fade-in fade-in-delay-1"
          style={{ color: "var(--text-muted)", marginBottom: "2.5rem", maxWidth: 900, marginInline: "auto" }}
        >
          Engineering projects spanning automotive, motorsport, marine, and
          railway systems from concept through simulation and physical prototyping to a viable product.
        </p>
        <div className="projects-grid fade-in fade-in-delay-2">
          {projects.map((p, i) => (
              <div key={i} className="project-card">
                <div className="project-icon">{p.icon}</div>
                <div className="project-title">{p.title}</div>
                <div className="project-org">{p.org}</div>
                <div className="project-desc">{p.description}</div>
                <div className="project-tags">
                  {p.tags.map((t, j) => (
                    <span key={j} className="project-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Projects;
